export const removeFirstZeroFromTPV = (tpv: string): string => {
  if (!/^\d+$/.test(tpv)) {
    return tpv // Return as is if tpv is not a number
  }
  return tpv.replace(/^0+/, '')
}
